import { injectable } from 'tsyringe';

import {
  UserMicrocertificate,
  UserMicrocertificateGateway,
} from '@/application/interfaces/user-microcertificate.interface';

@injectable()
export class PepeLegalUserMicrocertificateGateway
  implements UserMicrocertificateGateway
{
  async getMicrocertificate(
    hash: string,
  ): Promise<UserMicrocertificate | null> {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PEGASUS_PEPE_LEGAL_UG_PATH}/microcertificates/get-microcertificate?hash=${hash}`,
      );
      const json = await response.json();

      return json.data;
    } catch (error: any) {
      return null; // Handle it as not found
    }
  }
}
